// import { dateEnUS, dateZhCN, enUS, zhCN } from 'naive-ui';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import en from 'element-plus/dist/locale/en.mjs';
import es from 'element-plus/dist/locale/es.mjs';
import th from 'element-plus/dist/locale/th.mjs';
import vi from 'element-plus/dist/locale/vi.mjs';
import ko from 'element-plus/dist/locale/ko.mjs';

export const UILocales: Record<App.I18n.LangType, any> = {
  'zh-CN': zhCn,
  'en-US': en,
  'es-ES': es,
  'th-TH': th,
  'vi-VN': vi,
  'ko-KR': ko,
  'ht-HT': en
};

// export const naiveDateLocales: Record<LangType, NDateLocale> = {
//   'zh-CN': dateZhCN,
//   'en-US': dateEnUS
// };
